window.RewriteEngine = function() {
   var self = this,
      m_oRules = [];
   
   this.addRule = function(xPattern, aRules, oAdditionalParams) {
      m_oRules.push({
         pattern: new RegExp(xPattern),
         rules: aRules,
         additionalParams: oAdditionalParams
      });
   }
   
   this.match = function(sUrl) {
      var oParams = {};
      $.each(m_oRules, function(index, rule) {
         var aMatch = sUrl.match(rule.pattern);
         if (aMatch) {
            $.each(rule.rules, function(index, matchRule) {
               if (matchRule) {
                  oParams[matchRule] = aMatch[index];
               }
            });
            $.each(rule.additionalParams, function(key, value) {
               oParams[key] = value;
            });
         }
      });
      return oParams;
   }

};

window.RewriteRules = new RewriteEngine();

if(window.websiteCode == 'ESP') {
   window.RewriteRules.addRule("^/mls-busqueda/$", [null], {t: 0});
   window.RewriteRules.addRule("^/busqueda-inmobiliaria/$", [null], {t: 2});
   window.RewriteRules.addRule("^/busqueda-oficinas/$", [null], {t: 1});
   window.RewriteRules.addRule("^/buscar-por-lugar/$", [null], {});

   window.RewriteRules.addRule("^/propiedades-en-venta/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/propiedades-en-venta/[^/]*/([P][^/]*)/?$", [null, "ag"], {t: 0});
   window.RewriteRules.addRule("^/propiedades-en-venta/[^/]*/O([^/]*)/?$", [null, "of"], {t: 0});
   window.RewriteRules.addRule("^/propiedades-en-venta/[^/]*/T([^/]*)/?$", [null, "te"], {t: 0});
   window.RewriteRules.addRule("^/agentes-inmobiliarios/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 2});
   window.RewriteRules.addRule("^/agentes-inmobiliarios/[^/]*/O([^/]*)/?$", [null, "of"], {t: 2});
   window.RewriteRules.addRule("^/oficinas-inmobiliarias/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 1});
   window.RewriteRules.addRule("^/[^/]*/propiedades-en-venta/[^.]*/([0-9]+)-L([^/]*)/?$", [null, null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/escuelas/[^/]*/[^/]*/O([A-Z0-9]*)-L([A-Z0-9]*)$", [null, "inst_id", "lid"], {});

   window.RewriteRules.addRule("^/[^/]*/propiedades-en-venta/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/propiedades-en-venta/[^/]*/([P][^/]*)/?$", [null, "ag"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/propiedades-en-venta/[^/]*/O([^/]*)/?$", [null, "of"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/propiedades-en-venta/[^/]*/T([^/]*)/?$", [null, "te"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/agentes-inmobiliarios/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 2});
   window.RewriteRules.addRule("^/[^/]*/agentes-inmobiliarios/[^/]*/O([^/]*)/?$", [null, "of"], {t: 2});
   window.RewriteRules.addRule("^/[^/]*/oficinas-inmobiliarias/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 1});   
} else {
   window.RewriteRules.addRule("^/mls-address-search/$", [null], {t: 0});
   window.RewriteRules.addRule("^/agent-name-search/$", [null], {t: 2});
   window.RewriteRules.addRule("^/office-name-search/$", [null], {t: 1});
   window.RewriteRules.addRule("^/location-name-search/$", [null], {});

   window.RewriteRules.addRule("^/real-estate/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/real-estate/[^/]*/([P][^/]*)/?$", [null, "ag"], {t: 0});
   window.RewriteRules.addRule("^/real-estate/[^/]*/O([^/]*)/?$", [null, "of"], {t: 0});
   window.RewriteRules.addRule("^/real-estate/[^/]*/T([^/]*)/?$", [null, "te"], {t: 0});
   window.RewriteRules.addRule("^/real-estate-agents/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 2});
   window.RewriteRules.addRule("^/real-estate-agents/[^/]*/O([^/]*)/?$", [null, "of"], {t: 2});
   window.RewriteRules.addRule("^/real-estate-offices/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 1});
   window.RewriteRules.addRule("^/[^/]*/real-estate/[^.]*/([0-9]+)-L([^/]*)/?$", [null, null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/schools/[^/]*/[^/]*/O([A-Z0-9]*)-L([A-Z0-9]*)$", [null, "inst_id", "lid"], {});

   window.RewriteRules.addRule("^/[^/]*/real-estate/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/real-estate/[^/]*/([P][^/]*)/?$", [null, "ag"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/real-estate/[^/]*/O([^/]*)/?$", [null, "of"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/real-estate/[^/]*/T([^/]*)/?$", [null, "te"], {t: 0});
   window.RewriteRules.addRule("^/[^/]*/real-estate-agents/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 2});
   window.RewriteRules.addRule("^/[^/]*/real-estate-agents/[^/]*/O([^/]*)/?$", [null, "of"], {t: 2});
   window.RewriteRules.addRule("^/[^/]*/real-estate-offices/[^/]*/L([^/]*)/?$", [null, "lid"], {t: 1});   
}
